/* =========================================================
   Class Champions — cc-plp.js
   Collection page and search page (sections/cc-plp.liquid,
   sections/cc-search.liquid, snippets/cc-plp-card.liquid).

   - "Add to Cart" on a product card is a normal <form action="/cart/add">
     (works without JavaScript). With JavaScript it adds through the shared
     cart (window.ccCart, assets/cc-cart.js), which opens the cart drawer,
     then plays the celebration (window.ccCelebrate).
   - The sort control submits as soon as an option is picked.
   ========================================================= */
(function () {
  'use strict';

  // Forms with an add in progress. The button is not disabled while busy:
  // a disabled button drops keyboard focus.
  var adding = new WeakSet();

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-cc-plp-add]');
    if (!form || !window.ccCart) return;   // no shared cart: normal form post
    e.preventDefault();
    if (adding.has(form)) return;

    var button = form.querySelector('[type="submit"]');
    var label = button.textContent;
    adding.add(form);
    button.setAttribute('aria-disabled', 'true');
    button.textContent = 'Adding…';

    window.ccCart.add([{ id: Number(form.elements.id.value), quantity: 1 }], { open: true, trigger: button })
      .then(function () {
        if (window.ccCelebrate) window.ccCelebrate(button);
      }, function (err) {
        if (!err.ccCartShown) form.submit();   // network problem: fall back to a normal add
      })
      .then(function () {
        adding.delete(form);
        button.removeAttribute('aria-disabled');
        button.textContent = label;
      });
  });

  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-cc-plp-sort]');
    if (select) select.form.submit();
  });
})();
